"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when an argument is invalid because of: type, value or intention
 * @param {string} argumentName
 * @param {string} explanation
 */
class UnableToDecryptFieldError extends ExtendableError_1.default {
    constructor(field) {
        super(`Unable to decrypt field '${field}'`);
        this.field = field;
    }
}
exports.default = UnableToDecryptFieldError;
